import * as Yup from 'yup';

export const SendMessageFormValidationSchema = Yup.object().shape({
  recipients: Yup.string().nullable().required('This field is required'),

  subject: Yup.string()
    .max(255, 'You have exceeded the maximum number of 255 characters')
    .required('This field is required'),

  message: Yup.object()
    .test(
      'is-empty',
      'This field is required',
      value => value && value.getCurrentContent().hasText()
    )
    .test(
      'max-length',
      'You have exceeded the maximum number of 10000 characters',
      value =>
        value &&
        value.getCurrentContent().getPlainText('\u0001').length <= 10000
    ),

  attachments: Yup.array().when(
    ['attachmentsSize'],
    (attachmentsSize, schema) =>
      schema.of(
        Yup.object()
          .test(
            'overallSize',
            'The overall size of files is too big. Max size for all files is 6MB',
            () => 1024 * 1024 * 6 > attachmentsSize
          )
          .test(
            'maxSize',
            'The file is too big. Max file size is 5MB',
            value => value.file.size <= 5 * 1024 * 1024
          )
      )
  ),
});

export default SendMessageFormValidationSchema;
